module.exports = __webpack_public_path__ + "static/storytelling-pop-e5cbae25f303bad33762d0a39b78ff6b.svg";